import { useTranslation } from "react-i18next"

import ComingSoon from "@/components/shared/ComingSoon"

export const Scope2ComingSoon = () => {
  const { t } = useTranslation()
  return (
    <ComingSoon
      title={t("comingSoonRoutes.scope2.title")}
      description={t("comingSoonRoutes.scope2.description")}
      notifyMeButtonText={t("comingSoonRoutes.notifyMe")}
      // TODO: Add onNotifyMeButtonClick handler
    />
  )
}
